import { destroy, Instance, types } from 'mobx-state-tree'
import { v4 as uuid } from 'uuid'

export type BlockType = 'DEFAULT' | 'FILE' | 'TEXT' | 'LINK' | 'NOTE'

const Layout = types.model('Layout', {
  i: types.string,
  x: 0,
  y: 0,
  w: 4,
  h: 12,
  static: false
})
const Block = types
  .model('Block', {
    id: types.string,
    type: types.enumeration<BlockType>('Color', [
      'DEFAULT',
      'FILE',
      'TEXT',
      'LINK',
      'NOTE'
    ]),
    col: 4
  })
  .actions(self => ({
    updateCol: (col: number) => (self.col = col)
  }))

const Store = types
  .model('Store', {
    blocks: types.array(Block),
    layout: types.array(Layout)
  })
  .actions(self => ({
    addBlock: (type: BlockType) => {
      const id = uuid()
      self.blocks.push(
        Block.create({
          id,
          type: type || 'DEFAULT'
        })
      )
      let w = 4
      let h = 4

      if (type === 'TEXT') {
        w = 12
      }

      if (type === 'NOTE' || type === 'DEFAULT') {
        h = 12
      } else if (type === 'TEXT') {
        h = 2
      }

      self.layout.push({
        i: id,
        w,
        h,
        y: Infinity
      })
    },
    updateLayout: (layout: any) => (self.layout = layout),
    deleteBlock: (block: IBlock) => destroy(block)
  }))

const initialId = uuid()
export default Store.create({
  blocks: [Block.create({ id: initialId, type: 'DEFAULT' })],
  layout: [Layout.create({ i: initialId })]
})
export interface IBlock extends Instance<typeof Block> {}
